import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean | undefined;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('block text-sm font-medium text-iron mb-1', className)}
      {...props}
    >
      {children}
      {required && <span className="text-rust ml-0.5" aria-hidden="true">*</span>}
    </label>
  )
);
Label.displayName = 'Label';

export { Label };
